import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestAnnouncementActive = {
  path: "/announcement/:slug/active",
  method: RouteHttpVerb.POST
};